import { ReactElement, useState } from "react";
import { Body, Close, Footer, FooterItem, Header, Modal } from "@zendeskgarden/react-modals";
import { Field as FormField, Label } from "@zendeskgarden/react-forms";
import { Button } from "@zendeskgarden/react-buttons";
import { PayrollCompensationItemType } from "../../../__generated__/generated_types";
import { PayrollCompensationItemTypeLabel as payrollCompensationItemTypeLabel } from "../util";
import { InputField } from "./InputField";
import { Inline } from "@zendeskgarden/react-loaders";
import { ensureDateInLocale, ensureDateInUtc } from "../../../utils/helper-funcs";
import PayrollDatePicker from "../../../components/analyst-payroll-drawer/components/PayrollDatePicker";

export type BulkUpdateBenefitTaxInsProps = {
    onClose: () => void;
    onConfirm: (
        what: PayrollCompensationItemType,
        effectiveStartDate: Date | undefined,
        costPerPayPeriod: number | undefined,
        contributionCap: number | null | undefined
    ) => void;
    loading: boolean;
    updateWhat: PayrollCompensationItemType;
}

export function BulkUpdateBenefitTaxIns(props: BulkUpdateBenefitTaxInsProps): ReactElement {
    const [effectiveStartDate, setEffectiveStartDate] = useState<Date>();
    const [costPerPayPeriod, setCostPerPayPeriod] = useState<number>();
    const [contributionCap, setContributionCap] = useState<number>();

    const [clearContributionCap, setClearContributionCap] = useState(false);

    return (
    <Modal onClose={() => props.onClose()} isLarge style={{overflow: "unset"}}>
        <Header>
            Bulk Update {payrollCompensationItemTypeLabel(props.updateWhat)} Cost
        </Header>
        <Body>
            <div style={{flexDirection: "column", display: "flex", height: "500px"}}>
                <FormField style={{marginBottom: "1rem"}}>
                    <Label>Effective Start Date</Label>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <PayrollDatePicker
                            dateValue={ensureDateInLocale(effectiveStartDate)?.toISOString()}
                            onDateChange={(newDate) => {
                                setEffectiveStartDate(ensureDateInUtc(newDate));
                            }}
                        />
                        <Button onClick={() => setEffectiveStartDate(undefined)}>X</Button>
                    </div>

                </FormField>
                <InputField
                    title={[PayrollCompensationItemType.Medical, PayrollCompensationItemType.Vision, PayrollCompensationItemType.Dental].includes(props.updateWhat) ?
                            "Cost per Pay Period"
                            :
                            "% of Salary"
                        }
                    value={costPerPayPeriod}
                    setValue={setCostPerPayPeriod}
                />
                {
                ![PayrollCompensationItemType.Medical, PayrollCompensationItemType.Vision, PayrollCompensationItemType.Dental].includes(props.updateWhat) &&
                <InputField
                    title="Contribution Cap"
                    value={contributionCap}
                    setValue={setContributionCap}
                    clearValue={clearContributionCap}
                    setClearValue={setClearContributionCap}
                />
                }
            </div>
        </Body>
        <Footer>
            <FooterItem>
                <Button onClick={() => props.onClose()} isBasic disabled={false}>
                    Cancel
                </Button>
            </FooterItem>
            <FooterItem>
                {
                    <Button
                        isPrimary
                        onClick={() => {
                            props.onConfirm(props.updateWhat,
                                            effectiveStartDate,
                                            costPerPayPeriod,
                                            clearContributionCap ? null : contributionCap
                            )
                        }}
                        disabled={props.loading}
                    >
                        {
                            props.loading
                                ? <Inline size={24} aria-label="loading"/>
                                :
                                 <span>Confirm</span>
                        }
                    </Button>
                }
            </FooterItem>
        </Footer>
        <Close aria-label="Close modal" />
    </Modal>

    );
}